import * as R from "ramda";

export const isNumeric = (value: any): value is number =>
  !isNaN(parseFloat(value)) && isFinite(value);

export const getWithin = (value: number, min: number, max: number) =>
  R.compose(R.max(min), R.min(max))(value);
